import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/equipment/securityLaneIdentification/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/equipment/securityLaneIdentification/detail',
    method: 'get',
    params: data,
  })
}
export async function createData(data) {
  return request({
    url: '/equipment/securityLaneIdentification/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/equipment/securityLaneIdentification/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/equipment/securityLaneIdentification/delete',
    method: 'post',
    data,
  })
}
